import { Buttons, CancelButton, Drawer, Form, Tab, Tabs } from '~/components';
import { useDocumentTitle } from '~/hooks';
import React, { useState } from 'react';
import styled from 'styled-components';
import ReadTextbox from '~/components/read-only/ReadTextbox';
import opportunityStageCategories from '~/lookups/opportunity-stage-categories';
import { colors } from '~/styles';

const RawDataContainer = styled.pre`
  background-color: ${colors.grey5};
  border-radius: 0.3125rem;
  padding: 1rem;
  font-size: 0.75rem;
  overflow: auto;
  max-height: 400px;
  white-space: pre-wrap;
  word-wrap: break-word;
`;

function OpportunityStageViewDrawer({ opportunityStage, onClose }) {
  const title = 'View Opportunity Stage';
  useDocumentTitle(title);

  const hasIntegration = opportunityStage.hubspotData || opportunityStage.salesforceData;
  const integrationName = opportunityStage.hubspotData ? 'HubSpot' : 'Salesforce';
  const integrationData = opportunityStage.hubspotData || opportunityStage.salesforceData;

  const [tabIndex, setTabIndex] = useState(0);

  function handleClose() {
    if (onClose) {
      onClose();
    }
  }

  return (
    <Drawer isOpen title={title} byline="Custom Data" onClose={handleClose}>
      {hasIntegration && (
        <Tabs selectedIndex={tabIndex} onChange={(index) => setTabIndex(index)}>
          <Tab>Details</Tab>
          <Tab>{integrationName}</Tab>
        </Tabs>
      )}

      {tabIndex === 0 && (
        <Form.Section title="Details">
          <Form.Control>
            <ReadTextbox label="Name" value={opportunityStage.name} />
          </Form.Control>
          <Form.Control>
            <ReadTextbox label="Probability" value={opportunityStage.probability} prefix="%" />
          </Form.Control>
          <Form.Control>
            <ReadTextbox label="Category" value={opportunityStageCategories[opportunityStage.statusId].name} />
          </Form.Control>
          <Form.Control>
            <ReadTextbox label="Pipeline" value={opportunityStage.opportunityPipeline?.name} />
          </Form.Control>
          <Form.Control>
            <ReadTextbox label="Description" value={opportunityStage.description} textarea />
          </Form.Control>
        </Form.Section>
      )}

      {tabIndex === 1 && hasIntegration && (
        <Form.Section title={`${integrationName} Data`}>
          <RawDataContainer>{JSON.stringify(integrationData, null, 2)}</RawDataContainer>
        </Form.Section>
      )}

      <Drawer.Actions>
        <Buttons align="right">
          <CancelButton onClick={handleClose}>Close</CancelButton>
        </Buttons>
      </Drawer.Actions>
    </Drawer>
  );
}

export default OpportunityStageViewDrawer;
